<template>
  <a-modal
    v-if="visible"
    title="添加软性点评"
    :destroyOnClose="true"
    v-model="visible"
    :confirmLoading="loading"
    :width="1000"
    @ok="handleOk"
  >
    <h3>
      <b>候选人信息：</b>
    </h3>
    <a-row
      class="row"
      type="flex"
      justify="space-between"
      :gutter="20"
      style="padding:10px 0 0 25px"
    >
      <a-col span="12">
        <p>
          <b>候选人：</b>
          {{ record.resume_name }}
        </p>
      </a-col>
      <a-col span="12">
        <p>
          <b>职位：</b>
          {{ record.job_name }}
        </p>
      </a-col>
    </a-row>
    <soft-comment ref="comment"></soft-comment>
  </a-modal>
</template>

<script>
import SoftComment from "@/components/soft-comment";
import Api from "@/api";
export default {
  name: "CommentModal",
  data() {
    return {
      visible: false,
      loading: false,
      record: {}
    };
  },
  components: { SoftComment },
  computed: {},
  created() {},
  methods: {
    async show(record) {
      this.record = { ...record };
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    async handleOk() {
      this.loading = true;
      try {
        await this.softSkill();
        this.close();
        this.$emit("ok", this.record);
      } catch (e) {}
      this.loading = false;
    },
    softSkill() {
      return new Promise(async (resolve, reject) => {
        let tags = this.$refs.comment.getCommentFormData();
        if (tags) {
          try {
            await Api.resume.createSoftSkill({
              resume_id: this.record.resume_id,
              tags
            });
            resolve();
          } catch (e) {
            reject();
          }
        } else {
          reject();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
